import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../data/content";
import { Reveal, PageHeader, QuoteCTA, Marquee } from "../components/Shared";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader
        tag="Services"
        title={<>Concept to Install,<br />Under One Roof.</>}
        subtitle="A complete production pipeline — design, printing, fabrication, installation, and custom project management — with no outsourcing and no surprises."
      />

      <Marquee />

      <div className="py-20">
        <div className="msg-container space-y-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.05}>
              <div className="msg-card grid grid-cols-1 lg:grid-cols-12 overflow-hidden" data-testid={`service-card-${s.id}`}>
                <div className="lg:col-span-4 img-frame aspect-[4/3] lg:aspect-auto relative">
                  <img src={s.image} alt={s.title} loading="lazy" />
                </div>
                <div className="lg:col-span-8 p-8 lg:p-12">
                  <div className="flex items-center gap-5">
                    <span className="w-14 h-14 shrink-0 flex items-center justify-center" style={{ background: s.color, color: "#0A0A0C" }}>
                      <s.icon size={26} />
                    </span>
                    <span className="font-display font-black text-4xl lg:text-5xl" style={{ color: s.color }}>{s.num}</span>
                    <h2 className="font-display font-black uppercase tracking-tight text-2xl lg:text-3xl">{s.title}</h2>
                  </div>
                  <p className="mt-5 text-base md:text-lg leading-relaxed max-w-2xl" style={{ color: "var(--text-2)" }}>{s.desc}</p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {s.points.map((p) => (
                      <span key={p} className="font-mono text-[11px] tracking-wide uppercase px-3 py-2 border" style={{ borderColor: "var(--line)", color: "var(--text-2)" }}>{p}</span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="msg-container mt-14">
          <Link to="/quote" className="btn-brand" data-testid="services-quote-btn">Start Your Project <ArrowRight size={16} /></Link>
        </Reveal>
      </div>

      <QuoteCTA />
    </div>
  );
}
